// DPW steps
export const STEP_SELECT_DATA_SET = 0;
export const STEP_SELECT_DATA_TARGET = 1;
export const STEP_CREATE_DATA_LOADER = 2;

// DPW enable/disable actions
export const ENABLE_WORKFLOW = "ENABLE_WORKFLOW"
export const DISABLE_WORKFLOW = "DISABLE_WORKFLOW"
export const RESET_WORKFLOW = "RESET_WORKFLOW"
export const TRIGGER_MAIN_WORKFLOW = "TRIGGER_MAIN_WORKFLOW"

// DPW step actions
export const NEXT_STEP = "NEXT_STEP"
export const PREV_STEP = "PREV_STEP"
export const GOTO_STEP = "GOTO_STEP"

// DPW selecting data
export const TOGGLE_SELECTED_DATA_SET = "TOGGLE_SELECTED_DATA_SET"
export const TOGGLE_SELECTED_DATA_TARGET = "TOGGLE_SELECTED_DATA_TARGET"
export const SAVE_DATA_LOADER_FROM_STATE = "SAVE_DATA_LOADER_FROM_STATE" 